// eslint-disable-next-line yi/avoid-relative-parent-imports
import type { SaleValueType } from '../gql/generated/typesClient';

/**
 * NOTE this is probably legacy value type. And should be refactored or removed.
 * Use it with caution, the logic doesn't take currency into account.
 * */
export const AMOUNT_VALUE_TYPE = 'AMOUNT' as const;

export interface CouponDetails {
  // "value" can be null because we need to be able to safely add details from url search query string
  value: {
    amount: number;
    type: SaleValueType | typeof AMOUNT_VALUE_TYPE;
  } | null;
  coupon_code: string;
}
